export const GET_CANCELLATION_REASONS = gql`
    query cancellationReasons {
        cancellationReasons {
            id
            description
            status
            createdAt
            createdBy
            lastModifiedAt
            lastModifiedBy
        }
    }
`;

export const GET_CANCELLATION_REASON_BY_IS = gql`
    query cancellationReasonById($id: Int!) {
        cancellationReasonById(id: $id) {
            id
            description
            status
            createdAt
            createdBy
            lastModifiedAt
            lastModifiedBy
        }
    }
`;
